// src/config/featureKeys.js
export const FeatureKeys = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  VOICECALLS: 'VOICECALLS',
  CALLSEVALUATION: 'CALLSEVALUATION',
  CALLSEVALUATIONDETAILS: 'CALLSEVALUATIONDETAILS',
  PLAYSTORE: 'PLAYSTORE',
  APPSTORE: 'APPSTORE',
  USERS: 'USERS',
  ROLES: 'ROLES',
  CONFIGURATION: 'CONFIGURATION',
  TRANSCRIPTION: 'TRANSCRIPTION',
  APP_LINK: 'APP_LINK',
  USAGE: 'USAGE',
  MODEL_INTEGRATIONS: 'MODEL_INTEGRATIONS',
  API_DOCS: 'API_DOCS',
});


